import styled, { css } from 'styled-components';

import { lighten, darken } from 'utils/colours';
import { Input as AntdInput } from 'antd';

export const inputStylesOverride = css`
    &.ant-input-affix-wrapper:hover {
        border-color: ${({ theme }) => theme.colour.primary};
        border-right-width: 2px !important;
    }
    &.ant-input-affix-wrapper:focus,
    &.ant-input-affix-wrapper-focused {
        border-color: ${({ theme }) => theme.colour.primary};
        box-shadow: ${({ theme }) => `0 0 0 2px ${lighten(theme.colour.primary, 40)}`};
    }

    &.ant-input:hover {
        border-color: ${({ theme }) => theme.colour.primary};
        border-right-width: 1px !important;
    }
    &.ant-input:focus,
    &.ant-input-focused {
        border-color: ${({ theme }) => theme.colour.primary};
        box-shadow: ${({ theme }) => `0 0 0 2px ${lighten(theme.colour.primary, 40)}`};
    }
    &.ant-input-group-addon .ant-select-open .ant-select-selector,
    &.ant-input-group-addon .ant-select-focused .ant-select-selector {
        color: ${({ theme }) => darken(theme.colour.primary)};
    }

    &.ant-input-search-enter-button input:hover,
    &.ant-input-search-enter-button input:focus {
        border-color: ${({ theme }) => theme.colour.primary};
    }
`;

const Input = styled(AntdInput)`
    ${inputStylesOverride};
`;

export default Input;
